import { AffiliateLeadsModel, ReferralClaimResultModel } from '@models/affiliate';
import * as Sentry from '@sentry/nextjs';
import { useCallback, useState } from 'react';
import { useImprvApi } from './useImprvApi';

export const useAffiliateService = () => {
  const imprvApi = useImprvApi();
  const [isPendingGetEarnings, setIsPendingGetEarnings] = useState(false);
  const [isPendingRegisterReferral, setIsPendingRegisterReferral] = useState(false);

  const getAccountEarnings = useCallback(async (): Promise<AffiliateLeadsModel> => {
    try {
      setIsPendingGetEarnings(true);
      return await imprvApi.getAccountEarnings();
    } catch (error) {
      Sentry.captureException(error);
      throw error;
    } finally {
      setIsPendingGetEarnings(false);
    }
  }, [imprvApi]);

  const registerReferral = useCallback(
    async (referralCode: string): Promise<ReferralClaimResultModel> => {
      try {
        setIsPendingRegisterReferral(true);
        return await imprvApi.registerReferral(referralCode);
      } catch (error) {
        Sentry.captureException(error);
        throw error;
      } finally {
        setIsPendingRegisterReferral(false);
      }
    },
    [imprvApi]
  );

  return {
    getAccountEarnings,
    isPendingGetEarnings,
    registerReferral,
    isPendingRegisterReferral
  };
};
